<template>
  <div>
    <v-dialog v-model="visible" :max-width="width" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information-outline</v-icon>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <slot>
            {{label}}
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doCancel" v-if="info !== true && showCancelBtn === true">{{noLabel}}</v-btn>
          <v-btn color="primary" text @click.native="doOk" v-if="info !== true && showAcceptBtn === true">{{acceptLabel}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      resolve: null
    }
  },
  watch: {
    'value': function (value) {
      this.visible = value
    },
    'visible': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      }
    }
  },
  methods: {
    doOk() {
      this.$emit('ok')
      if (this.resolve) {
        this.resolve(true)
      }
      this.visible = false
    },
    doCancel() {
      this.$emit('cancel')
      if (this.resolve) {
        this.resolve(false)
      }
      this.visible = false
    },
    doPopUp() {
      // used inside a method. Sample code:
      // this.$refs.{component's ref}.doPopUp().then(result => console.log(result))
      this.visible = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'System Warning'
    },
    label: {
      type: String,
      default: ''
    },
    acceptLabel: {
      type: String,
      default: 'Accept'
    },
    noLabel: {
      type: String,
      default: 'Cancel'
    },
    width: {
      type: Number,
      default: 400
    },
    info: {
      type: Boolean,
      default: false
    },
    showAcceptBtn: {
      type: Boolean,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    }
  },
  beforeMount() {
    // Some init
    this.visible = this.value
  }
}
</script>

<style lang="scss">

</style>
